(function () {
  'use strict';

  // B2B Price Calculator - BSS B2B数量折扣表格增强器
  // 动态为BSS B2B插件生成的数量折扣表格添加"折后价（Price）"列

  // 获取产品原价
  function getOriginalPrice() {
    const priceElement = document.querySelector('[data-compare-at-price]');
    if (priceElement) {
      const compareAtPrice = parseFloat(priceElement.getAttribute('data-compare-at-price'));
      if (!isNaN(compareAtPrice)) {
        const originalPrice = parseFloat(compareAtPrice / 100);
        return originalPrice;
      }
    }
    return null;
  }

  // 格式化价格
  function formatPrice(price) {
    if (isNaN(price)) return 'N/A';

    // 转为字符串，截断到小数点后两位
    let [intPart, decPart = ''] = String(price).split('.');

    // 只保留前两位，不补零
    decPart = decPart.slice(0, 2);

    // 拼接结果
    let formatted = decPart.length > 0 ? `${intPart}.${decPart}` : `${intPart}.00`;
    if (decPart.length === 1) formatted += '0';
    if (decPart.length === 0) formatted = `${intPart}.00`;

    // 检测货币符号
    const currencySymbol = detectCurrencySymbol();

    return `${currencySymbol}${formatted}`;
  }

  // 检测货币符号
  function detectCurrencySymbol() {
    const priceElements = document.querySelectorAll('.price, [class*="price"]');

    for (const element of priceElements) {
      const text = element.textContent;
      if (text.includes('$')) return '$';
      if (text.includes('¥')) return '¥';
      if (text.includes('€')) return '€';
      if (text.includes('£')) return '£';
    }

    return '$'; // 默认美元符号
  }

  // 验证折扣值的合理性
  function validateDiscount(discountType, discountValue, originalPrice) {
    if (discountType === 'percentage') {
      // 百分比折扣应该在0-100%之间
      if (discountValue < 0 || discountValue > 1) {
        console.log('Invalid percentage discount value:', discountValue);
        return false;
      }

      // 折后价不应该为负数
      const discountedPrice = originalPrice * (1 - discountValue);
      if (discountedPrice < 0) {
        console.log('Invalid discounted price:', discountedPrice);
        return false;
      }
    } else if (discountType === 'amount') {
      // 金额折扣应该为正数且小于原价
      if (discountValue <= 0 || discountValue >= originalPrice) {
        console.log('Invalid amount discount value:', discountValue);
        return false;
      }

      // 折后价不应该为负数
      const discountedPrice = originalPrice - discountValue;
      if (discountedPrice < 0) {
        console.log('Invalid discounted price:', discountedPrice);
        return false;
      }
    } else {
      console.log('Unknown discount type:', discountType);
      return false;
    }

    return true;
  }

  // 更新表格价格列
  function updateColumnPrice(row) {
    const originalPrice = getOriginalPrice();
    if (!originalPrice) {
      console.log('No original price found');
      return 'N/A';
    }

    const cells = Array.from(row.cells || row.children);
    let discountType = null; // 'percentage' 或 'amount'
    let discountValue = 0;
    let discountFound = false;

    console.log('Processing row with', cells.length, 'cells');

    // 验证表格结构：至少应该有2列（数量和折扣）
    if (cells.length < 2) {
      console.log('Invalid table structure: insufficient columns');
      return formatPrice(originalPrice);
    }

    // 检查是否为自定义报价行
    if (row.classList.contains('custom-quote-row')) {
      console.log('Custom quote row detected');
      return 'Custom Quote';
    }

    // 查找折扣信息 - 从第二列开始（跳过数量列）
    for (let i = 1; i < cells.length; i++) {
      const cell = cells[i];
      const text = cell.textContent.trim();
      console.log(`Cell ${i}: "${text}"`);

      // 跳过空单元格
      if (!text) {
        continue;
      }

      // 查找百分比折扣 - 支持多种格式
      const percentMatch = text.match(/(\d+(?:\.\d+)?)%/);
      if (percentMatch) {
        discountType = 'percentage';
        discountValue = parseFloat(percentMatch[1]) / 100;
        discountFound = true;
        console.log(`Found percentage discount: ${percentMatch[1]}%`);
        break;
      }

      // 查找固定金额折扣 - 支持多种货币符号和格式
      const amountMatch = text.match(/[\$¥€£]?([\d,]+\.?\d*)/);
      if (amountMatch) {
        const discountAmount = parseFloat(amountMatch[1].replace(/,/g, ''));
        if (!isNaN(discountAmount) && discountAmount > 0) {
          discountType = 'amount';
          discountValue = discountAmount;
          discountFound = true;
          console.log(`Found amount discount: ${discountAmount}`);
          break;
        }
      }
    }

    // 如果没有找到折扣信息，返回原价
    if (!discountFound) {
      console.log('No discount found, using original price');
      return formatPrice(originalPrice);
    }

    // 验证折扣值
    if (!validateDiscount(discountType, discountValue, originalPrice)) {
      console.log('Invalid discount, using original price');
      return formatPrice(originalPrice);
    }

    // 计算折后价
    let discountedPrice;
    if (discountType === 'percentage') {
      // 百分比折扣：原价 * (1 - 折扣比例)
      console.log('Original price:', originalPrice, 'Percentage discount:', discountValue);
      discountedPrice = originalPrice * (1 - discountValue);
    } else if (discountType === 'amount') {
      // 金额折扣：原价 - 折扣金额
      console.log('Original price:', originalPrice, 'Amount discount:', discountValue);
      discountedPrice = originalPrice - discountValue;
    } else {
      console.log('Unknown discount type, using original price');
      return formatPrice(originalPrice);
    }

    console.log('Discounted price:', discountedPrice);

    // 格式化价格
    return formatPrice(discountedPrice);
  }

  // 在原有的enhanceQuantityTable函数中添加对新显示区域的更新
  function enhanceQuantityTable() {
    // 修正表格选择器为 B2B 专用
    const tables = document.querySelectorAll('.bss-b2b-cart-item-qty-table .quantity_break_table');

    // 1. 先移除所有 buy more tip，避免重复和插入错误位置
    document.querySelectorAll('.b2b-buy-more-tip').forEach((el) => el.remove());

    tables.forEach((table) => {
      // 2. 始终插入 Buy more save more! 提示到表格上方
      const bssTableContainer = table.closest('.bss-b2b-cart-item-qty-table');
      if (bssTableContainer) {
        console.log('insert buy more tip');
        const tip = document.createElement('div');
        tip.className = 'b2b-buy-more-tip';
        tip.textContent = 'Buy more save more!';
        bssTableContainer.parentNode.insertBefore(tip, bssTableContainer);
        // 2. 隐藏表头标题
        const headerTitle = bssTableContainer.querySelector('.bss-b2b-cart-item-qty-table-header-title');
        if (headerTitle) {
          headerTitle.style.display = 'none';
        }
      }

      // Add price column if not exists
      if (!table.querySelector('.bss-price-column')) {
        const headerRow = table.querySelector('thead tr');
        const priceHeader = document.createElement('th');
        priceHeader.className = 'bss-price-column';
        priceHeader.innerHTML = `Price<br/><span class="bss-price-column-msrp">MSRP $${getOriginalPrice()}</span>`;
        headerRow.appendChild(priceHeader);
      }

      // Get all quantity rows
      const rows = Array.from(table.querySelectorAll('.bss-b2b-qty-table-row'));

      // 计算价格列
      rows.forEach((row) => {
        const hasPriceColumn =
          row.querySelector('.bss-price-column, .bss-price-cell') !== null ||
          Array.from(row.cells || row.children).some(
            (cell) => cell.textContent.includes('Price') || cell.textContent.includes('价格')
          );
        if (!hasPriceColumn) {
          const priceCell = document.createElement('td');
          priceCell.className = 'bss-price-cell';
          priceCell.style.cssText = ``;

          const calculatedPrice = updateColumnPrice(row);
          priceCell.textContent = calculatedPrice;

          row.appendChild(priceCell);
        }
      });
      const maxQuantity = getMaxQuantityFromTable();
      const customQuoteRow = document.querySelector('.bss-b2b-qty-table-row.custom-quote-row');

      // Add custom quote row for quantities exceeding the maximum tier
      if (maxQuantity !== Infinity && !customQuoteRow) {
        const tbody = table.querySelector('tbody');
        const customQuoteRow = document.createElement('tr');
        customQuoteRow.className = 'bss-b2b-qty-table-row custom-quote-row';
        customQuoteRow.setAttribute('data-min', maxQuantity + 1);
        customQuoteRow.setAttribute('data-max', 'infinite');

        customQuoteRow.innerHTML = `
          <td>${maxQuantity}+</td>
          <td></td>
          <td class="bss-price-cell">Custom Quote</td>
        `;

        tbody.appendChild(customQuoteRow);
      }
    });
  }

  function updateQuantityPriceSummary(quantity) {
    console.log('updateQuantityPriceSummary123', quantity);
    const unitPriceElement = document.querySelector('[data-unit-price-value]');
    const totalPriceElement = document.querySelector('[data-total-price-value]');
    if (!unitPriceElement || !totalPriceElement) return;

    // 更新数量显示
    const quantityValueElement = document.querySelector('[data-quantity-value]');
    if (quantityValueElement) {
      quantityValueElement.textContent = quantity;
    }

    // 获取梯度价格
    const tierPrice = getTierPrice(quantity);

    const formattedUnitPrice = formatPrice(tierPrice);
    const totalPrice = quantity * tierPrice;
    const formattedTotalPrice = formatPrice(totalPrice);

    unitPriceElement.textContent = formattedUnitPrice;
    totalPriceElement.textContent = formattedTotalPrice;
  }

  // 获取梯度价格数据
  function getTieredPriceDataFromMetaFields() {
    const priceContainer = document.querySelector('.product-page-main-price[data-tiered-price]');
    if (priceContainer) {
      let tieredPrice;
      try {
        tieredPrice = JSON.parse(priceContainer.getAttribute('data-tiered-price'));
      } catch (e) {
        tieredPrice = null;
      }
      return tieredPrice;
    }
  }

  // 获取指定数量对应的梯度价格
  function getTierPrice(quantity) {
    const tieredPrice = getTieredPriceDataFromMetaFields();
    if (tieredPrice && Array.isArray(tieredPrice.prices)) {
      let price = getOriginalPrice();
      let lastValidPrice = price; // 记录最后一个有效的价格

      // 按 min 字段排序，确保从小到大遍历
      const sortedPrices = [...tieredPrice.prices].sort((a, b) => {
        const minA = parseInt(a.min, 10) || 1;
        const minB = parseInt(b.min, 10) || 1;
        return minA - minB;
      });

      for (const item of sortedPrices) {
        const min = parseInt(item.min, 10) || 1;
        const max = item.max !== undefined && item.max !== null ? parseInt(item.max, 10) : null;

        if ((max === null && quantity >= min) || (max !== null && quantity >= min && quantity <= max)) {
          // 如果当前价格是 -1，使用最后一个有效价格
          if (item.price === -1) {
            price = lastValidPrice;
          } else {
            price = item.price;
            lastValidPrice = item.price; // 更新最后一个有效价格
          }
          break;
        }

        // 记录非 -1 的有效价格
        if (item.price !== -1) {
          lastValidPrice = item.price;
        }
      }
      return price;
    }
    return getOriginalPrice();
  }

  // 独立函数：获取价格表中的最大数量
  function getMaxQuantityFromTable() {
    const tieredPrice = getTieredPriceDataFromMetaFields();
    if (tieredPrice && Array.isArray(tieredPrice.prices)) {
      const customRow = tieredPrice.prices.find((item) => Number(item.price) === -1);
      if (customRow && customRow.min) {
        return parseInt(customRow.min, 10);
      }
    }
    return 200;
  }

  // 监听 BSS B2B 表格的渲染
  function observeBssTableRender() {
    // 监听整个 body，确保异步渲染也能捕获
    const container = document.body;
    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      let hasTable = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // const tt =
          //   node?.matches('.bss-b2b-cart-item-qty-table') ||
          //   node.querySelector?.('.bss-b2b-cart-item-qty-table .quantity_break_table');
          // console.log('tt123', tt);
          // const bssTable =
          //   node.querySelector?.(
          //     '.bss-b2b-cart-item-qty-table, [class*="bss-b2b"], [class*="bss-qty"], [class*="quantity-discount"]'
          //   ) || (node.classList?.contains('bss-b2b-cart-item-qty-table') ? node : null);
          // console.log('bssTable123', bssTable);
          if (
            node.nodeType === 1 &&
            (node.matches('.bss-b2b-cart-item-qty-table') ||
              node.querySelector?.('.bss-b2b-cart-item-qty-table .quantity_break_table'))
          ) {
            // 检查新插入的表格
            // 找到所有.bss-b2b-cart-item-qty-table元素
            const bssTables = node.matches('.bss-b2b-cart-item-qty-table')
              ? [node]
              : node.querySelectorAll('.bss-b2b-cart-item-qty-table');
            bssTables.forEach((bssTable) => {
              enhanceQuantityTable();
              updateQuantityPriceSummary(1);
            });
          }
        });
      });
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  // 在 DOMContentLoaded 时调用
  document.addEventListener('DOMContentLoaded', function () {
    enhanceQuantityTable();
    updateQuantityPriceSummary(1);
    observeBssTableRender(); // 新增监听

    // 监听数量输入变化 - 采用方案一：直接监听 quantity-input 组件(注意不是input dom)
    const quantityInputComponent = document.querySelector('quantity-input');
    if (quantityInputComponent) {
      quantityInputComponent.addEventListener('change', (e) => {
        const value = quantityInputComponent.querySelector('input[name="quantity"]').value;
        console.log('quantityInputComponent Change', value, e.target.value);
        enhanceQuantityTable();
        updateQuantityPriceSummary(value);
      });
    }

    // 更新报价按钮文本
    const quoteButton = document.querySelector('.b2b-quote-button');
    if (quoteButton) {
      const maxQuantity = getMaxQuantityFromTable();
      quoteButton.textContent = `Get a quote for ${maxQuantity}pc or more`;
    }
  });
})();
